import { useEffect } from 'react'

import { getEnvVar } from '../utils/env'

const HUBSPOT_PORTAL_ID = getEnvVar('HUBSPOT_ID')
const IS_PRODUCTION_BUILD =
  (getEnvVar('NODE_ENV') ?? 'development') === 'production'

export const useHubspotScript = (isFigma: boolean): void => {
  useEffect(() => {
    if (IS_PRODUCTION_BUILD && !isFigma && HUBSPOT_PORTAL_ID) {
      const script = document.createElement('script')
      script.src = `https://js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`
      script.id = 'hs-script-loader'
      script.async = true
      document.body.appendChild(script)
      return () => {
        document.body.removeChild(script)
      }
    }
  }, [isFigma])
}
